const internals = { memory: new Map(), ranks: new Map() };

const keyFor = ({ schoolId, userId, roleId } = {}) => schoolId === 240394 && roleId === 2 && Number.isInteger(userId) ? `nearpeer-leaderboard:${schoolId}:${roleId}:${userId}` : null;
const periodFor = (period) => period === 'allTime' ? 'allTime' : 'weekly';

module.exports = {
    read(scope) {

        const key = keyFor(scope);
        let value = {};
        if (key) {
            try {
                value = internals.memory.get(key) || JSON.parse(sessionStorage.getItem(key) || 'null') || {};
            }
            catch (error) {
                value = internals.memory.get(key) || {};
            }
        }
        return { view: !!value.view, period: periodFor(value.period), ids: Array.isArray(value.ids) ? [...new Set(value.ids.filter((id) => Number.isInteger(id) && id > 0))] : [], scrollTop: Math.max(0, Number(value.scrollTop) || 0) };
    },
    write(scope, patch) {

        const key = keyFor(scope);
        if (!key) {
            return;
        }
        const value = { ...module.exports.read(scope), ...patch };
        internals.memory.set(key, value);
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
        catch (error) { /* In-memory navigation still works when browser storage is unavailable. */ }
    },
    rememberRanks(scope, period, rows) {

        const key = keyFor(scope);
        if (!key) { return; }
        const cacheKey = `${key}:${periodFor(period)}`;
        internals.ranks.delete(cacheKey);
        internals.ranks.set(cacheKey, { at: Date.now(), rows: Object.fromEntries(rows.filter(({ rank, points }) => Number.isInteger(rank) && rank > 0 && (points === undefined || points > 0)).map(({ id, rank }) => [id, rank])) });
        // Retain only a small, short-lived cache, isolated by the viewing account.
        if (internals.ranks.size > 8) { internals.ranks.delete(internals.ranks.keys().next().value); }
    },
    recentRank(scope, period, userId) {

        const key = keyFor(scope);
        const saved = key && internals.ranks.get(`${key}:${periodFor(period)}`);
        return saved && Date.now() - saved.at < 60000 ? saved.rows[userId] || null : null;
    },
    clearRanks(scope) {

        const key = keyFor(scope);
        if (!key) { return; }
        internals.ranks.delete(`${key}:weekly`);
        internals.ranks.delete(`${key}:allTime`);
    },
    profileUrl(id, index, period) {

        return `/app/profile/${id}?fromLeaderboard=true&leaderboardPeriod=${periodFor(period)}&index=${index}&achievements=1`;
    },
    profileContext(scope, search, userId) {

        const params = new URLSearchParams(search);
        const saved = module.exports.read(scope);
        const index = saved.ids.indexOf(Number(userId));
        return params.get('fromLeaderboard') === 'true' && saved.view && saved.period === periodFor(params.get('leaderboardPeriod')) && index >= 0 ? { ...saved, index } : null;
    },
    isLeaderboard(scope, search) {

        return !!keyFor(scope) && new URLSearchParams(search).get('fromLeaderboard') === 'true';
    }
};
